import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const examManagementRoutes: RouteRecordRaw = {
  path: "/examManagement",
  component: Layout,
  redirect: "/examManagement/examProjectList",
  name: "ExamManagement",
  meta: {
    title: "考试管理",
    icon: "homepage",
    permissionKey: "examManagement",
  },
  children: [
    {
      path: "examProjectList",
      name: "ExamProjectList",
      component: () =>
        import("@/views/Workbench/exam-management/exam-project-list/index.vue"),
      meta: {
        title: "考试项目",
        icon: "homepage",
        permissionKey: "examManagement:examProjectList",
      },
    },
    {
      path: "newExamProject",
      name: "NewExamProject",
      component: () =>
        import("@/views/Workbench/exam-management/exam-project-editor/new.vue"),
      meta: {
        title: "创建考试项目",
        icon: "homepage",
        hidden: true,
        permissionKey: "examManagement:newExamProject",
      },
    },
    {
      path: "editExamProject",
      name: "EditExamProject",
      component: () =>
        import("@/views/Workbench/exam-management/exam-project-editor/detail.vue"),
      meta: {
        title: "编辑考试项目",
        icon: "homepage",
        hidden: true,
        permissionKey: "examManagement:editExamProject",
      },
    },
    {
      path: "examProjectDetail",
      name: "ExamProjectDetail",
      component: () =>
        import("@/views/Workbench/exam-management/exam-project-editor/detail.vue"),
      meta: {
        title: "考试项目详情",
        icon: "homepage",
        hidden: true,
        permissionKey: "examManagement:viewExamProject",
      },
    },
    {
      path: "examStudentList",
      name: "ExamStudentList",
      component: () =>
        import("@/views/Workbench/exam-management/exam-student-list/index.vue"),
      meta: {
        title: "考生列表",
        icon: "homepage",
        permissionKey: "examManagement:examStudentList",
      },
    },
    {
      path: "examSchoolList",
      name: "ExamSchoolList",
      component: () =>
        import("@/views/Workbench/exam-management/exam-school-list/index.vue"),
      meta: {
        title: "考点统计",
        icon: "homepage",
        permissionKey: "examManagement:examSchoolList",
      },
    },
    {
      path: "examAutoScoreList",
      name: "ExamAutoScoreList",
      component: () =>
        import("@/views/Workbench/exam-management/exam-auto-score-list/index.vue"),
      meta: {
        title: "场次统计",
        icon: "homepage",
        permissionKey: "examManagement:examAutoScoreList",
      },
    },
    {
      path: "examSchoolStatisticsDetail",
      name: "ExamSchoolStatisticsDetail",
      component: () =>
        import("@/views/Workbench/exam-management/exam-school-statistics-detail/index.vue"),
      meta: {
        title: "考点统计详情",
        icon: "homepage",
        hidden: true,
        permissionKey: "examManagement:examSchoolStatisticsDetails",
      },
    },
    {
      path: "studentScoreList",
      name: "ExamManagementStudentScoreList",
      component: () =>
        import("@/views/Workbench/exam-management/exam-student-score-list/index.vue"),
      meta: {
        title: "考生成绩",
        icon: "homepage",
        permissionKey: "examManagement:examStudentScoreList",
      },
    },
    {
      path: "examProjectReport",
      name: "ExamProjectReport",
      component: () =>
        import("@/views/Workbench/exam-management/exam-project-report/index.vue"),
      meta: {
        title: "项目报告",
        icon: "homepage",
        hidden: true,
        permissionKey: "statisticsManagement:examProjectReport",
      },
    },
  ],
};

export default examManagementRoutes;
